import { useMutation } from 'react-query'
import useCacheKeys from '../../hooks/use-cache-keys'
import useCache from '../../hooks/use-cache'
import useApi from '../../hooks/use-api'
import useCurrentUser from '../../hooks/use-current-user'
import useToasts from '../../hooks/use-toasts'
import useConfirmationDialog from '../../hooks/use-confirmation-dialog'
import moment from 'moment';

export const useCourseEnroller = ({
    course = {},
    onSuccess = () => {},
}) => {
    const { id: userId } = useCurrentUser()
    const cacheKeys = useCacheKeys()
    const { clearCache } = useCache({ key: cacheKeys.COURSES, onReload: onSuccess})
    const { api, url, endpoints } = useApi()
    const { toastSuccess } = useToasts({ successMessage: 'Experience added!', onSuccess: clearCache })
    const { toastError } = useToasts()
    const { id: courseId } = course;
    const [ mutate, {isLoading} ] = useMutation(
        () => api.post(url(endpoints.userCourseEnrollment, { userId, courseId })),
        {
            onSuccess: toastSuccess,
            onError: toastError
        }
    )

    const { showConfirmation: confirmSameDayEnrollment } = useConfirmationDialog({
        onConfirm: mutate,
        title: 'Same day experience?',
        description: 'ALERT: This experience MAY HAVE already occurred. Do you still want to enroll?'
    })

    const enroll = () => {
        if (moment(course.date).diff(moment(), 'days') === 0) {
            confirmSameDayEnrollment();
        } else {
            mutate();
        }
    }

    return {
        isLoading,
        enroll,
        confirmSameDayEnrollment
    }
}

export default useCourseEnroller